
export class SelectListItem {
    Disabled: boolean;
    Selected: boolean;
    Text: string;
    Value: string;
}
   